import React from 'react'
import './logo.css'
import LogoS from '../../../assets/images/logo-s.png'

function Logo() {
    return (
        <div className='logo-container '>
            <img className='solid-logo' src={LogoS} alt='s' />
            

        </div>
    )
}

export default Logo;
